import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../Header";
import Footer from "../Footer";
import AuthModal from "./AuthModal";
import MemberShell from "./MemberShell";
import useCoWorkUser from "../../hooks/useCoWorkUser";
import useCoWorkBranding from "../../hooks/useCoWorkBranding";
import { fetchCoWorkSettings } from "../../api";

// The frame of every members-only Co-Work page (dashboard, messages, AI assistant): site header / footer,
// the Co-Work title + favicon + logo, the profile sidebar, and the signed-out / admin states.
// `children` is a function receiving { user, settings, setUser, refresh } once a buyer or seller is signed in.
export default function MemberPage({ title, children }) {
  const navigate = useNavigate();
  const { user, setUser, refresh, signOut } = useCoWorkUser();
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    fetchCoWorkSettings().then(setSettings).catch(() => {});
  }, []);

  useCoWorkBranding(settings);
  useEffect(() => {
    document.title = `${title} - ${settings?.browser_title || "Co-Work"}`;
  }, [title, settings]);

  let content;
  if (user === undefined) {
    content = <p className="text-gray-400">Loading...</p>;
  } else if (user === null) {
    content = (
      <div className="text-center py-20">
        <h1 className="text-3xl font-bold">Sign in to continue</h1>
        <p className="text-gray-400 mt-2">Buyers and sellers manage their work, messages and profile here.</p>
        <AuthModal settings={settings} onClose={() => navigate("/co-work")} onAuthenticated={refresh} />
      </div>
    );
  } else if (!user.role) {
    content = (
      <div className="text-center py-20">
        <h1 className="text-3xl font-bold">Administrator account</h1>
        <p className="text-gray-400 mt-2 mb-6">Admins moderate jobs, proposals and members from the admin panel.</p>
        <Link to="/admin/pages/co-work/jobs" className="px-6 py-2.5 rounded-full bg-brand-gradient font-semibold">Open Admin Panel</Link>
      </div>
    );
  } else {
    content = children({ user, settings, setUser, refresh });
  }

  return (
    <>
      <Header logo={settings?.logo} />
      <div className="h-16" />
      <main className="bg-navy text-white min-h-[70vh] py-10">
        <MemberShell user={user} onSignOut={signOut}>
          <Link to="/co-work" className="inline-block text-accent-light text-sm mb-6 hover:underline">&larr; Back to Co-Work</Link>
          {content}
        </MemberShell>
      </main>
      <Footer />
    </>
  );
}
